// ─── src/api/meetupEvents.ts ──────────────────────────────────────────────────

import { apiClient } from "./registration";
import type {
  MeetupEvent,
  MeetupEventAdminList,
  MeetupEventParams,
} from "../types/meetupEvent";
import type { PaginationMeta } from "../types/registration";
import type { UpdateMeetupEventPayload } from "../components/dashboard/EditEventModal";

export type { UpdateMeetupEventPayload };

const BASE = "/meetup-events";

export interface NormalisedMeetupEvents {
  data: MeetupEvent[];
  meta: PaginationMeta;
}

const normalise = (raw: MeetupEventAdminList): NormalisedMeetupEvents => ({
  data: raw.data,
  meta: {
    total:      raw.total,
    page:       raw.page,
    limit:      raw.limit,
    totalPages: Math.ceil(raw.total / raw.limit),
  },
});

export const getMeetupEvents = async (
  params: MeetupEventParams,
): Promise<NormalisedMeetupEvents> => {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== "" && v !== null),
  );
  const { data } = await apiClient.get<MeetupEventAdminList>(`${BASE}/admin`, { params: clean });
  return normalise(data);
};

export const deleteMeetupEvent = async (id: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${id}`);
};

/**
 * Admin edit for a published meetup event. Uses the x-api-key admin auth
 * (the catalyst edit goes through a different endpoint with a JWT).
 */
export const updateMeetupEvent = async (
  id: string,
  payload: UpdateMeetupEventPayload,
): Promise<MeetupEvent> => {
  const { data } = await apiClient.patch<MeetupEvent>(`${BASE}/${id}`, payload);
  return data;
};
